import { createSelector, createSlice } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux"

type LicensesSettingsSlice = {
    selectedLicenseIds: string[]
    assignToMemberId: string
    assignToNonMemberEmail: string
}

const initialState: LicensesSettingsSlice = {
    selectedLicenseIds: [],
    assignToMemberId: "",
    assignToNonMemberEmail: "",
}

export const licensesSettingsSliceName = "licensesSettings" as const

export const {
    actions: {
        toggleSelectedLicenseId,
        setAssignToMemberId,
        setAssignToNonMemberEmail,
        resetAssignModal,
    },
    reducer: LicensesSettingsSliceReducer,
} = createSlice({
    name: licensesSettingsSliceName,
    initialState,
    reducers: {
        toggleSelectedLicenseId: (state, action: { payload: string }) => {
            const id = action.payload
            if (state.selectedLicenseIds.includes(id)) {
                state.selectedLicenseIds = state.selectedLicenseIds.filter((i) => i !== id)
            } else {
                state.selectedLicenseIds.push(id)
            }
        },
        setAssignToMemberId: (state, action: { payload: string }) => {
            state.assignToMemberId = action.payload
        },
        setAssignToNonMemberEmail: (state, action: { payload: string }) => {
            state.assignToNonMemberEmail = action.payload
        },
        resetAssignModal: () => initialState,
    },
})

const root = (state: RootState) => state[licensesSettingsSliceName]

export const selectSelectedLicenseIds = createSelector([root], (s) => s.selectedLicenseIds)
export const selectAssignToMemberId = createSelector([root], (s) => s.assignToMemberId)
export const selectAssignToNonMemberEmail = createSelector([root], (s) => s.assignToNonMemberEmail)
